import { render } from "./PersonalCat.vue?vue&type=template&id=647d80d2&scoped=true"
import script from "./PersonalCat.vue?vue&type=script&lang=js"
export * from "./PersonalCat.vue?vue&type=script&lang=js"

import "./PersonalCat.vue?vue&type=style&index=0&id=647d80d2&scoped=true&lang=css"

import exportComponent from "/var/www/html/genesis-git/vue-genesis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-647d80d2"]])

export default __exports__